// extracted by mini-css-extract-plugin
module.exports = {"container":"i1bMTTEs","fadeIn":"kW_GG25T","tooltip":"Jp_fiVGm","name":"UcnxbDQ4","id":"BOo__8u3"};